import { useQuery } from "@apollo/react-hooks";
import { MY_TIME_GET_MONTHLY_WORK_TIME_BALANCE } from "my-time/graphql/queries";

interface MonthlyWorkTimeBalanceParams {
  contractCode: string;
  year: number;
  month: number;
}

export const useMyTimeMonthlyWorkTimeBalance = ({
  contractCode,
  year,
  month,
}: MonthlyWorkTimeBalanceParams) => {
  const { data, loading, error } = useQuery(
    MY_TIME_GET_MONTHLY_WORK_TIME_BALANCE,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        contractCode,
        year,
        month,
      },
    },
  );

  return {
    data: data?.getMonthlyWorkTimeBalance || {},
    loading,
    error,
  };
};

export default useMyTimeMonthlyWorkTimeBalance;
